export enum DashboardType {
  ClientHours = "Client Hours",
  ProviderHours = "Provider Hours",
  IntakeSummary = "Intake Dashboard",
  OnboardingSummary = "Onboarding Dashboard",
}